var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 16.5235H10.6939C11.8776 16.5235 13.0613 18.3389 14.245 18.3389C15.2681 18.3389 17.1754 17.4348 18.0563 19.1431C18.3347 19.6831 17.9629 20.3 17.4114 20.5338C16.1342 21.0752 14.7115 21.8108 14.245 21.9698L10.6939 20.7595M18.3879 19.5492L23.8044 17.3339C24.1332 17.1994 24.4908 17.1556 24.8414 17.2068C26.0804 17.3878 26.4305 19.0473 25.3745 19.7344L16.3266 25.6216C15.7555 25.9932 15.0561 26.097 14.4053 25.9069L3 22.575M11.2858 8.05146V11.0772C11.2858 12.7482 12.6107 14.1029 14.245 14.1029C15.8793 14.1029 17.2042 12.7482 17.2042 11.0772V8.05146M11.2858 8.05146V5.02573C11.2858 3.35466 12.6107 2 14.245 2C15.8793 2 17.2042 3.35466 17.2042 5.02573V8.05146M11.2858 8.05146H17.2042",
    stroke: "#4F84E8",
    strokeWidth: 1.752,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedication);
export default __webpack_public_path__ + "static/media/medication.0465fb420d373bc2d8d329187476b703.svg";
export { ForwardRef as ReactComponent };